import { Verdict } from '@exam-management/graphql';
import {
  type FlexProps,
  CancelOutlinedIcon,
  CheckCircleOutlineRoundedIcon,
  Flex,
  styled,
  Text,
} from '@shared/components';

interface ReviewResultLabelProps extends FlexProps {
  variant: 'CONTAINED' | 'TEXT';
  result?: Verdict | null;
}

const ContainedStyledLabel = styled(Flex)(({ theme }) => ({
  width: 'fit-content',
  color: theme.palette.text.secondary,
  backgroundColor: theme.palette.grey[100],
  padding: theme.spacing(2.5, 4),
  borderRadius: theme.shape.rounded(2),
  fontSize: theme.typography.body1.fontSize,
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const TextStyledLabel = styled(Flex)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: theme.typography.body1.fontSize,
  alignItems: 'center',
  gap: theme.spacing(1),
}));

export default function ReviewResultLabel(props: Readonly<ReviewResultLabelProps>) {
  const { result, variant, sx } = props;
  let label: string;
  let icon: JSX.Element | null;
  switch (result) {
    case Verdict.Approved:
      label = 'เห็นด้วย';
      icon = <CheckCircleOutlineRoundedIcon color='success' fontSize='small' />;
      break;
    case Verdict.Rejected:
      label = 'ไม่เห็นด้วย';
      icon = <CancelOutlinedIcon color='error' fontSize='small' />;
      break;
    case undefined:
    default:
      label = 'ยังไม่ระบุ';
      icon = null;
      break;
  }

  switch (variant) {
    case 'CONTAINED':
      return (
        <ContainedStyledLabel sx={sx}>
          {icon}
          <Text variant='body2'>{label}</Text>
        </ContainedStyledLabel>
      );
    case 'TEXT':
      return (
        <TextStyledLabel sx={sx}>
          {icon}
          <Text variant='body2'>{label}</Text>
        </TextStyledLabel>
      );
  }
}
